import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"
import type { Niche } from "@/shared/lib/types"

const fetchNiches = async (): Promise<Niche[]> => {
	const { data } = await apiClient.get<Niche[]>("/niches")
	return data
}

export const useNiches = () => {
	return useQuery({
		queryKey: ["niches"],
		queryFn: fetchNiches,
	})
}
